// frontend-testimonials-slider.js
function initP7TestimonialsSlider(sliderBlock) {
    if (!sliderBlock || sliderBlock.classList.contains('p7-slider-initialized')) return;

    const mainSliderEl = sliderBlock.querySelector('.p7-testimonials-slider-main');
    if (!mainSliderEl) return;

    if (typeof Swiper === 'undefined') {
        console.warn('Swiper not loaded yet, retrying...');
        setTimeout(() => initP7TestimonialsSlider(sliderBlock), 500);
        return;
    }

    const slidesPerView = parseInt(sliderBlock.dataset.slidesPerView, 10) || 4;
    const loop = sliderBlock.dataset.loop === 'true';
    const autoPlay = sliderBlock.dataset.autoplay === 'true';
    const delay = parseInt(sliderBlock.dataset.delay, 10) || 5000;

    const prevButton = sliderBlock.querySelector('.p7-testimonials-slider-nav-prev');
    const nextButton = sliderBlock.querySelector('.p7-testimonials-slider-nav-next');

    const swiperInstance = new Swiper(mainSliderEl, {
        slidesPerView: slidesPerView,
        spaceBetween: 20,
        loop: loop,
        slidesPerGroup: slidesPerView,
        slidesPerGroup: 1,
        speed: 1200,
        autoplay: autoPlay ? { delay, disableOnInteraction: false, pauseOnMouseEnter: true } : false,
        navigation: {
            prevEl: prevButton,
            nextEl: nextButton,
        },
        observer: true,
        observeParents: true,
        observeSlideChildren: true,
        breakpoints: {
            0: { slidesPerView: 1, slidesPerGroup: 1 },
            768: { slidesPerView: 2, slidesPerGroup: 1 },
            1025: { slidesPerView: slidesPerView, slidesPerGroup: 1 },
        }
    });

    // Store swiper instance on the block element
    sliderBlock.swiperInstance = swiperInstance;
    sliderBlock.classList.add('p7-slider-initialized');

    // Add click handler for read more buttons INSIDE this slider
    sliderBlock.addEventListener('click', function(e) {
        const btn = e.target.closest('.testimonial-read-more');
        if (!btn) return;

        e.preventDefault();
        e.stopPropagation();
        
        const wrapper = btn.closest('.testimonial-description');
        if (!wrapper) return;

        const textEl = wrapper.querySelector('.testimonial-text');
        if (!textEl) return;

        const expanded = btn.classList.toggle('is-open');

        textEl.textContent = expanded
            ? wrapper.dataset.full
            : wrapper.dataset.trimmed;

        btn.textContent = expanded ? 'Read less' : 'Read more';
    });
}


/* ===== Init all testimonial sliders ===== */
function initializeAllP7TestimonialsSliders() {
    document
        .querySelectorAll('.p7-testimonials-slider-block:not(.p7-slider-initialized)')
        .forEach(initP7TestimonialsSlider);
}

/* Initial load */
document.addEventListener('DOMContentLoaded', () => {
    initializeAllP7TestimonialsSliders();
    setTimeout(initializeAllP7TestimonialsSliders, 1000);
});

/* Gutenberg support */
if (typeof wp !== 'undefined' && wp.data && wp.data.subscribe) {
    let timeout;
    wp.data.subscribe(() => {
        clearTimeout(timeout);
        timeout = setTimeout(() => {
            document.querySelectorAll('.p7-testimonials-slider-block.p7-slider-initialized').forEach(block => {
                if (block.swiperInstance) {
                    block.swiperInstance.destroy(true, true);
                    block.classList.remove('p7-slider-initialized');
                }
            });
            initializeAllP7TestimonialsSliders();
        }, 120);
    });
}

/* Resize support */
if (window.frameElement && window.frameElement.classList.contains('is-resizable')) {
    const resizeObserver = new ResizeObserver(() => {
        setTimeout(initializeAllP7TestimonialsSliders, 60);
    });
    resizeObserver.observe(document.body);
}

/* Global API */
window.p7TestimonialsSlider = {
    initSlider: initP7TestimonialsSlider,
    initAllSliders: initializeAllP7TestimonialsSliders,
    destroyAllSliders() {
        document.querySelectorAll('.p7-testimonials-slider-block.p7-slider-initialized').forEach(block => {
            if (block.swiperInstance) {
                block.swiperInstance.destroy(true, true);
                block.classList.remove('p7-slider-initialized');
            }
        });
    },
};

// document.addEventListener('click', function (e) {
//     const btn = e.target.closest('.testimonial-read-more');
//     if (!btn) return;

//     const wrapper = btn.closest('.testimonial-description');
//     if (!wrapper) return;

//     const textEl = wrapper.querySelector('.testimonial-text');
//     if (!textEl) return;

//     const expanded = btn.classList.toggle('is-open');

//     textEl.textContent = expanded
//         ? wrapper.dataset.full
//         : wrapper.dataset.trimmed;

//     btn.textContent = expanded ? 'Read less' : 'Read more';
// });
